import { useTravelataAppConfig } from '@/shared/composables';
import type { OperatorProductDTO } from '@/shared/model';
import { normalizeOperatorNaming } from '../lib/operatorGroup';

export default class OperatorProduct {
  readonly id: number;
  readonly name: string;
  readonly nameRu: string;
  readonly cover: string;

  constructor(data: OperatorProductDTO) {
    const appConfig = useTravelataAppConfig();
    const { id, name, nameRu } = normalizeOperatorNaming(data);
    this.id = id;
    this.name = name;
    this.nameRu = nameRu;
    this.cover = `${appConfig.imagesDomain}/photos/operator/${id}.png`;
  }
}
